// A SYSADMIN acting as a system user (routes/impersonation.js; server.js X-Act-As). Kept for the session only, like
// the workspace choice: a reload goes on acting, a closed tab or a sign-out ends it. The uid is stored with it so a
// different account signing into the same tab never inherits it, and the workspace so a switch away acts as nobody.

const KEY = 'dp.actAs'

export interface ActingAs {
  uid: string
  tenantId: string
  membershipId: string
  email: string
  name: string | null
  permission_set: string
}

export function readActAs(): ActingAs | null {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const v = JSON.parse(raw)
    return v && typeof v.uid === 'string' && typeof v.tenantId === 'string' && typeof v.membershipId === 'string' ? v : null
  } catch {
    return null
  }
}

export function writeActAs(v: ActingAs) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(v))
  } catch {
    // Storage blocked: acting as someone cannot outlive this request, so it does not start.
  }
}

export function clearActAs() {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // Nothing stored to clear.
  }
}

// Whom a request by this account in this workspace acts as, if anyone.
export function actingFor(uid: string | undefined, tenantId: string | null): ActingAs | null {
  const v = readActAs()
  return v && tenantId && v.tenantId === tenantId && (!uid || v.uid === uid) ? v : null
}
